<template>
  <div>
    <component v-bind:is="switchLayout()"></component>
    <!--    <authLayout></authLayout>-->
    <loading v-if="getLoading"></loading>
    <ModalIdle />
  </div>
</template>

<script>
import authLayout from "@/layouts/auth-layout";
import adminLayout from "@/layouts/admin-layout";
import loading from "@/components/default/loading";
import ModalIdle from "@/components/default/ModalIdle";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "App",
  components: {
    "auth-layout": authLayout,
    "admin-layout": adminLayout,
    loading: loading,
    ModalIdle
  },
  data() {
    return {
      route_use_login_template: ["login", "YS-Login"]
    };
  },
  computed: {
    ...mapGetters("Layout", ["getLoading"])
  },
  methods: {
    switchLayout() {
      if (this.route_use_login_template.indexOf(this.$route.name) !== -1) {
        return "auth-layout";
      } else {
        return "admin-layout";
      }
    },
    handleBrowserClose() {
      if (
        performance.getEntriesByType("navigation")[0].type != "navigate" &&
        performance.getEntriesByType("navigation")[0].type != "reload"
      ) {
        if (Cookies.get("uid")) {
          this.$store.dispatch("Auth/Logout");
          this.$router.push("/login");
        }
      }
    }
  },
  // updated() {
  //   sessionStorage.setItem("route", this.$router.history.current.name);
  // },
  created() {
    window.addEventListener("beforeunload", this.handleBrowserClose());
    // window.addEventListener(
    //   "beforeunload",
    //   function(e) {
    //     if (sessionStorage.getItem("route") !== "login") {
    //       e.preventDefault();
    //       Cookies.remove("uid");
    //       sessionStorage.removeItem("route");
    //       e.returnValue = "";
    //     }
    //   },
    //   false
    // );
  }
};
</script>
<style lang="scss">
@import "./App.scss";
</style>
